import { SupportedLanguage } from "Stores/I18nStore";

export default class LanguageHelper {
	public static getSupportedLanguage(language: string): SupportedLanguage {
		return Object.values(SupportedLanguage).find((value) => value === language) ?? SupportedLanguage.EN;
	}
}
